import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../Event/event';

const EstimateWithHundreds = () => {
  const [numbers, setNumbers] = useState([]);
  const [estimate, setEstimate] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackClass, setFeedbackClass] = useState('');
  const [showNew, setShowNew] = useState(false);

  const inputRef = useRef();

  const getRandomNumber = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  const roundToNearestHundred = (n) => Math.round(n / 100) * 100;

  const generateNumbers = () => {
    const newNums = Array.from({ length: 4 }, () => getRandomNumber(100, 999));
    setNumbers(newNums);
    setEstimate('');
    setFeedback('');
    setFeedbackClass('');
    setShowNew(false);
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  const getCorrectEstimate = () => {
    return numbers.reduce((sum, n) => sum + roundToNearestHundred(n), 0);
  };

  const checkAnswer = () => {
    if (estimate.trim() === '' || isNaN(estimate)) {
      setFeedback('Please enter a number!');
      setFeedbackClass('incorrect');
      return;
    }

    const userValue = parseInt(estimate, 10);
    const correct = getCorrectEstimate();

    if (userValue === correct) {
      setFeedback(`🎉 Great job! The estimate is correct: ${correct}`);
      setFeedbackClass('correct');
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setShowNew(true);
    } else {
      setFeedback("Oops! That's not quite right. Try again!");
      setFeedbackClass('incorrect');
    }
  };

  useEffect(() => {
    generateNumbers();
  }, []);

  const styles = {
    body: {
      margin: 0,
      fontFamily: "'Comic Sans MS', sans-serif",
      background: 'linear-gradient(to right, #fefae0, #d4a373)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '1rem',
      boxSizing: 'border-box',
    },
    box: {
      background: '#fff',
      borderRadius: '20px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
      padding: '2rem',
      width: '100%',
      maxWidth: '420px',
      textAlign: 'center',
    },
    h1: {
      color: '#bc6c25',
      marginBottom: '1.2rem',
      fontSize: '1.8rem',
    },
    instruction: {
      fontSize: '1.1rem',
      marginBottom: '1rem',
      color: '#333',
    },
    numberList: {
      fontSize: '1.2rem',
      marginBottom: '1.5rem',
      color: '#5f370e',
      lineHeight: '1.6',
    },
    input: {
      fontSize: '1.2rem',
      padding: '0.6rem 1rem',
      border: '3px solid #bc6c25',
      borderRadius: '10px',
      width: '100%',
      maxWidth: '400px',
      textAlign: 'center',
      marginBottom: '1rem',
    },
    button: {
      fontSize: '1rem',
      padding: '0.7rem 1.4rem',
      border: 'none',
      background: '#bc6c25',
      color: 'white',
      borderRadius: '25px',
      cursor: 'pointer',
      margin: '0.5rem',
    },
    feedback: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      minHeight: '30px',
    },
    correct: {
      color: '#2d6a4f',
    },
    incorrect: {
      color: '#b00020',
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.box}>
        <h2 style={styles.h1}>Estimate with Hundreds</h2>
        <div style={styles.instruction}>
          Round each number to the nearest hundred and add them!
        </div>
        <div style={styles.numberList}>
          {numbers.map((n, i) => (
            <div key={i}>Number {i + 1}: {n}</div>
          ))}
        </div>

        <input
          type="number"
          ref={inputRef}
          value={estimate}
          onChange={(e) => setEstimate(e.target.value)}
          placeholder="Your Estimate"
          style={styles.input}
          onKeyDown={(e) => e.key === 'Enter' && checkAnswer()}
          disabled={showNew}
        />
        <br />
        {!showNew ? (
          <button style={styles.button} onClick={checkAnswer}>Check Answer</button>
        ) : (
          <button style={styles.button} onClick={generateNumbers}>New Numbers</button>
        )}
        <div
          style={{
            ...styles.feedback,
            ...(feedbackClass === 'correct'
              ? styles.correct
              : feedbackClass === 'incorrect'
                ? styles.incorrect
                : {}),
          }}
          role="alert"
          aria-live="polite"
        >
          {feedback}
        </div>
      </div>
    </div>
  );
};

export default EstimateWithHundreds;
